'use client'

import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { TransactionTitle } from '~/components/component-library/TransactionTitle'
import { useRejectTransaction } from '~/hooks/smart-account-actions/useRejectTransaction'
import { OrgTransaction } from '~/types'

export const RejectTransactionDialog = ({
  orgId,
  transaction,
  setIsOpen,
}: {
  orgId: string
  transaction: OrgTransaction
  setIsOpen: (isOpen: boolean) => void
}) => {
  const { rejectTransaction, isProcessing } = useRejectTransaction()

  return (
    <SplitsDialogContent
      id="rejectTransaction"
      title={
        <>
          Cancel{' '}
          <b>
            <TransactionTitle transaction={transaction} isSmall unstyled />
          </b>
          ?
        </>
      }
      isLoading={isProcessing}
      variant="destructive"
      deleteButton={{
        text: 'Yes, cancel',
        onClick: async () => {
          await rejectTransaction(orgId, transaction)
          setIsOpen(false)
        },
        eventProperties: {
          transactionId: transaction.id,
        },
      }}
      cancelButton={{
        text: 'Keep it',
        eventProperties: {
          transactionId: transaction.id,
        },
      }}
    >
      <p>
        Canceled transactions are immediately removed from your workspace and
        are unable to be submitted.
      </p>
    </SplitsDialogContent>
  )
}
